import React, { FC } from 'react';
import { LoginPageV2 } from 'aw-package-react-authentication';
import LangueFr from './translations/fr';
import LangueEn from './translations/en';

export interface LoginPageProps {
  mobileDeviceMode: boolean;
}

const LoginPage: FC<LoginPageProps> = ({ mobileDeviceMode }) => {
  if (mobileDeviceMode) {
    sessionStorage.setItem('mobileDeviceMode', 'true');
  }
  return (
    <LoginPageV2 titleCustomEn={LangueEn.title} titleCustomFr={LangueFr.title} mobileDeviceMode={mobileDeviceMode} />
  );
};

export default LoginPage;
